import { random } from '@/utils/helpers'

export function scopedClassNames<T extends string>(keys: T[]): Record<T, string> {
    const rnd = Math.round(random() * 36 ** 6)
    return Object.fromEntries(keys.map((key, i) => [key, `t${(rnd + i + 1).toString(36)}`])) as Record<T, string>
}
